export * as SairAccount from "./sair-account.js"

import { Schema } from "effect"
import { ephemeral, inventory } from "./event.js"
import { optional } from "./schema.js"

export interface Profile extends Schema.Schema.Type<typeof Profile> {}
export const Profile = Schema.Struct({
  sairId: Schema.String,
  name: Schema.String,
  email: Schema.String,
  avatarUrl: Schema.String,
  // Access reports effective cloud eligibility. Workspace browser-auth profiles
  // have a different contract and omit this field; absence is never a grant.
  compute: optional(Schema.Boolean),
  remoteWorkspace: optional(Schema.Struct({ url: Schema.String, audience: Schema.String })),
}).annotate({ identifier: "SairAccount.Profile" })

export interface Attempt extends Schema.Schema.Type<typeof Attempt> {}
export const Attempt = Schema.Struct({
  attemptID: Schema.String,
  userCode: Schema.String,
  verificationUrl: Schema.String,
  expiresAt: Schema.Finite.annotate({ description: "Authorization deadline as Unix milliseconds." }),
  interval: Schema.Finite.annotate({ description: "Minimum device polling interval in seconds." }),
}).annotate({ identifier: "SairAccount.Attempt" })

export interface Issue extends Schema.Schema.Type<typeof Issue> {}
export const Issue = Schema.Struct({
  code: Schema.String,
  message: Schema.String,
  retryAfter: optional(Schema.Finite),
}).annotate({ identifier: "SairAccount.Issue" })

export class RequestError extends Schema.TaggedError<RequestError>()("SairAccount.RequestError", {
  code: Schema.String,
  message: Schema.String,
  retryAfter: optional(Schema.Finite),
}) {}

export interface Status extends Schema.Schema.Type<typeof Status> {}
export const Status = Schema.Struct({
  auth: Schema.Literals(["signed_out", "authorizing", "authenticated", "unavailable"]),
  model: Schema.Literals(["unavailable", "ready", "error"]),
  profile: optional(Profile),
  attempt: optional(Attempt),
  error: optional(Issue),
  modelError: optional(Issue),
}).annotate({ identifier: "SairAccount.Status" })

export interface LogoutResult extends Schema.Schema.Type<typeof LogoutResult> {}
export const LogoutResult = Schema.Struct({
  status: Status,
  revoked: Schema.Boolean,
  error: optional(Issue),
}).annotate({ identifier: "SairAccount.LogoutResult" })

const Updated = ephemeral({ type: "sair.account.updated", schema: {} })
export const Event = { Updated, Definitions: inventory(Updated) }
